import { ArtiaButtonLink } from '@/components/artia-button';
import { CalculationDetails } from '@/types/calculation-details';
import { ProprietaryCalculatedValue } from '@/types/proprietary-calculated-value';
import { formatPercent } from '@/utils/formatting';

type UraPercentWacCellProps = {
  uraPercentWac: ProprietaryCalculatedValue
  onViewCalculationDetails: (calculationDetails: CalculationDetails) => void;
};

export const UraPercentWacCell = ({ uraPercentWac, onViewCalculationDetails }: UraPercentWacCellProps) => {
  const handleViewCalculatedCalculationDetails = () => {
    // @ts-expect-error TS(2345): Argument of type 'CalculationDetails | undefined' ... Remove this comment to see the full error message
    onViewCalculationDetails(uraPercentWac.calculatedValue);
  };

  const handleViewProprietaryCalculationDetails = () => {
    // @ts-expect-error TS(2345): Argument of type 'CalculationDetails | undefined' ... Remove this comment to see the full error message
    onViewCalculationDetails(uraPercentWac.proprietaryValue);
  };

  return (
    <div className="min-w-32">
      {uraPercentWac?.proprietaryValue?.value != null
        && <ArtiaButtonLink onClick={() => handleViewProprietaryCalculationDetails()}>
          {formatPercent(uraPercentWac.proprietaryValue?.value, 2, 2)}
        </ArtiaButtonLink>
      }

      {uraPercentWac?.proprietaryValue?.value == null && uraPercentWac?.calculatedValue?.value != null
        && <ArtiaButtonLink onClick={() => handleViewCalculatedCalculationDetails()}>
          {formatPercent(uraPercentWac.calculatedValue?.value, 2, 2)}
        </ArtiaButtonLink>
      }
    </div>
  );
};
